/**
 * @fileoverview Agent definition for scenes-rebuilder-v1.
 *
 * Refreshes scenes to reflect what was actually written in the chapter content.
 * Unlike the old scenes-updater, this agent can add, remove, merge, or split scenes
 * to match the actual structure of the written prose.
 *
 * @category narrative.chapters.scenes
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'scenes-rebuilder-v1',
  kind: 'primitive',
  name: 'Scenes Rebuilder',
  description: 'Rebuilds the scene breakdown from actual chapter content. Can add, remove, merge, or split scenes as needed.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.chapters.scenes',
    usedBy: [
      'primitives/use-scenes-rebuilder-v1.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'scene-architect-v2',
      'chapter-entity-detector-v2',
    ],
  },
};
